const apiKeyTypes = {
  read_only: { id: 'read_only', name: 'Read-Only' },
  full: { id: 'full', name: 'Full Access' },
};

export default apiKeyTypes;
